import React, { memo, useState, useRef, useEffect } from "react";
import {
  TouchableOpacity,
  View,
  Image,
  Dimensions,
  ScrollView,
  StyleSheet,
} from "react-native";
import CloseIcon from "@assets/svg/CloseIcon";
import Next from "@assets/svg/Navigation/Next";
import Previous from "@assets/svg/Navigation/Previous";
// import Text from "@components/AppText";
import colors from "@constants/color";
import Button from "@components/Button";
import WhatsappWhite from "@assets/svg/WhatsappWhite";
import { Modal } from "@components/TrackedModal";
import {
  CLICK_OFFER_CTA,
  VIEW_OFFER_MODAL,
} from "../constants/analyticsEvents";

import t from "../constants/localization";

const PATH = "components/GalleryModal";

const { height, width } = Dimensions.get("window");

const OFFER_IMG_WIDTH = width * 0.9;
const OFFER_IMG_AR = 1.5;
const OFFER_IMG_HEIGHT = OFFER_IMG_AR * OFFER_IMG_WIDTH;

const GalleryModal = memo((props) => {
  const {
    data = [],
    showModal = false,
    handleGalleryModalOpen = () => {},
    shareOfferOnWhatsapp = () => {},
    onClickTlOffer = (e) => {},
    clickedIndex,
  } = props;
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const listRef = useRef(null);

  useEffect(() => {
    scrollList(currentImageIndex, true);
  }, [currentImageIndex]);

  useEffect(() => {
    setCurrentImageIndex(clickedIndex);
  }, [clickedIndex]);

  const {
    promotion_type = "",
    image = "",
    url = "",
    id: promotion_id,
  } = data[currentImageIndex] || {};

  const isCustomer =
    data[currentImageIndex] &&
    (promotion_type === "customer" || promotion_type === "Customer");

  const btnText = !isCustomer ? t(`${PATH}/viewOffer`) : t(`${PATH}/share`);
  const btnColor = !isCustomer ? colors.primary : colors.lima;

  const shouldDisableOfferButton = () => !isCustomer && url === "";

  const scrollList = (index, isAnimated) => {
    if (listRef.current) {
      const offset = index * width;
      listRef.current.scrollTo({ x: offset, animated: isAnimated });
    }
  };

  const handleNextPrevClick = (next = true) => {
    let index = currentImageIndex;

    if (!next) {
      if (index === 0) {
        return;
      }
      index -= 1;
    } else {
      if (index === data.length - 1) {
        return;
      }
      index += 1;
    }

    setCurrentImageIndex(index);
  };

  return (
    <Modal
      statusBarTranslucent
      navigationBarTranslucent
      animationType="fade"
      visible={showModal}
      transparent
      eventName={VIEW_OFFER_MODAL}
      eventPayload={{
        promotion_id,
        url,
        promotion_type,
        image,
      }}
      onRequestClose={handleGalleryModalOpen}
    >
      <View
        style={{
          backgroundColor: "rgba(0, 0, 0, .8)",
          paddingVertical: 16,
          flex: 1,
          alignItems: "center",
          justifyContent: "center",
          height,
        }}
      >
        <View>
          <TouchableOpacity
            onPress={handleGalleryModalOpen}
            style={{
              position: "absolute",
              right: 15,
              padding: 20,
              zIndex: 10,
              top: 25,
            }}
          >
            <CloseIcon fill="#fff" />
          </TouchableOpacity>
          {data.length > 1 && (
            <TouchableOpacity
              style={{
                position: "absolute",
                top: "50%",
                left: 15,
                zIndex: 11,
                padding: 10,
                backgroundColor: "rgba(0, 0, 0, .8)",
                height: 30,
                width: 30,
                borderRadius: 15,
                justifyContent: "center",
                alignItems: "center",
              }}
              disabled={currentImageIndex === 0}
              onPress={() => {
                handleNextPrevClick(false);
              }}
            >
              <Previous
                strokeColor={currentImageIndex === 0 ? "#aaa" : "#fff"}
              />
            </TouchableOpacity>
          )}
          <ScrollView
            horizontal
            pagingEnabled
            onMomentumScrollEnd={(obj) => {
              const currentIndex = (
                obj.nativeEvent.contentOffset.x / Dimensions.get("window").width
              ).toFixed(0);

              setCurrentImageIndex(Number(currentIndex));
            }}
            showsHorizontalScrollIndicator={false}
            ref={(view) => (listRef.current = view)}
          >
            {data.map((offer, index) => (
              <View
                key={`gallery-item-${index}`}
                style={{
                  width,
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <Image
                  source={{ uri: offer.image }}
                  style={{
                    height: OFFER_IMG_HEIGHT,
                    width: OFFER_IMG_WIDTH,
                    // flex: 1,
                  }}
                  resizeMode="contain"
                />
              </View>
            ))}
          </ScrollView>
          {!shouldDisableOfferButton() && (
            <View style={styles.shareButtonContainer}>
              <View
                style={{
                  width: width / 2,
                }}
              >
                {url && url.length > 1 && (
                  <Button
                    btnText={btnText}
                    buttonColor={btnColor}
                    onPress={() => {
                      handleGalleryModalOpen();

                      isCustomer
                        ? shareOfferOnWhatsapp(image, url)
                        : onClickTlOffer(url);
                    }}
                    buttonFontType="content2"
                    buttonWidth="100%"
                    height={40}
                    borderRadius={20}
                    iconForStdBtn={
                      isCustomer && <WhatsappWhite style={{ marginTop: 2 }} />
                    }
                    disabled={shouldDisableOfferButton()}
                    eventName={CLICK_OFFER_CTA}
                    eventPayload={{
                      offer_id: promotion_id,
                      offer_image: image,
                      offer_url: url,
                      offer_type: promotion_type,
                      action: "gallery modal click",
                    }}
                  />
                )}
              </View>
            </View>
          )}
          {data.length > 1 && (
            <TouchableOpacity
              style={{
                position: "absolute",
                top: "50%",
                right: 15,
                padding: 10,
                backgroundColor: "rgba(0, 0, 0, .8)",
                height: 30,
                width: 30,
                borderRadius: 15,
                justifyContent: "center",
                alignItems: "center",
              }}
              disabled={currentImageIndex === data.length - 1}
              onPress={handleNextPrevClick}
            >
              <Next
                strokeColor={
                  currentImageIndex === data.length - 1 ? "#aaa" : "#fff"
                }
              />
            </TouchableOpacity>
          )}
        </View>
      </View>
    </Modal>
  );
});

const styles = StyleSheet.create({
  shareButtonContainer: {
    justifyContent: "center",
    alignItems: "center",
    bottom: 15,
    position: "absolute",
    width: "100%",
  },
});

export default GalleryModal;
